/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  BookingService,
  UserService,
  PaymentService,
  PujaService,
} from "../../Services/index";
import Footer from "../../Component/Footer/Footer";
import Whatsapp from "../../Component/Whatsapp/Whatsapp";
import "./BookingDetail.scss";
import LoginModal from "../../Component/Login/Login";
import Header from "../../Component/Header";
import Loader from "../../Component/Loader/Loader";
import OrderStatus from "../../Component/OrderStatus/OrderStatus";
import SamagiriList from "../../Component/SamagiriList/SamagiriList";
import PujariSamagiri from "../../Component/PujariSamagiri/PujariSamagiri";
import KarishyeSamagiri from "../../Component/KarishyeSamagiri/KarishyeSamagiri";
import PriceBreakup from "../../Component/PriceBreakup/PriceBreakup";
import {
  EVENT_CATEGORIES,
  EVENT_ACTIONS,
  EVENT_LABELS,
} from "../../Constants/myDharmaContent";

function EachBooking() {
  // State management
  const [userId, setUserId] = useState(null);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [transaction, setTransaction] = useState([]);
  const [remaining, setRemaining] = useState([]);
  const [payment, setPayment] = useState("full");
  const [inputPayment, setInputPayment] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [user, setUser] = useState({});
  const [loginModal, setLoginModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isPaymentCompleted, setIsPaymentCompleted] = useState(false);
  const [bannerImageUrl, setBannerImageUrl] = useState(null);
  const [totalPaidAmount, setTotalPaidAmount] = useState(0);
  const [signupFormData, setSignupFormData] = useState({
    name: "",
    surname: "",
    phoneNumber: "",
  });

  // UI state
  const [isCustomerOpen, setIsCustomerOpen] = useState(false);
  const [isProcedureOpen, setIsProcedureOpen] = useState(false);
  const [isNotesOpen, setIsNotesOpen] = useState(false);
  const [isPriceBreakupOpen, setIsPriceBreakupOpen] = useState(false);

  const { bookingNumber } = useParams();

  // API Functions
  const calculateTotalCost = (samagriData) => {
    if (!Array.isArray(samagriData)) {
      console.error("Expected an array but got", samagriData);
      return 0;
    }
    return samagriData.reduce((total, item) => {
      if (item.isProvidedBy === "karishye") {
        return total + item?.samagri?.customerMrp * item.qty;
      }
      return total;
    }, 0);
  };

  const calculateSamagriCost = (samagriData) => {
    // Calculate only Karishye samagri cost for payment (exclude pujari samagri)
    if (!Array.isArray(samagriData)) {
      return 0;
    }
    console.log(samagriData, "samagriData")
    return samagriData.reduce((total, item) => {
      if (item.isProvidedBy === "karishye") {
        return total + (item?.samagri?.customerMrp * item.qty || 0);
      }
      return total;
    }, 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "To Be Decided";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "To Be Decided";

      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch (error) {
      console.error("Error formatting date:", error);
      return "To Be Decided";
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "To Be Decided";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "To Be Decided";

      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (error) {
      console.error("Error formatting date time:", error);
      return "To Be Decided";
    }
  };

  // Modify the getTransaction function to calculate remaining amount and payment completion
  const getTransaction = async (bookingId) => {
    setIsLoading(true);
    try {
      const transactions = await BookingService.getTransactions(bookingId);
      setTransaction(transactions);

      // Calculate total paid amount from all transactions
      const totalPaidAmount = transactions.reduce(
        (sum, transaction) => sum + transaction.paidAmount,
        0
      );
      console.log("totalPaidAmount", totalPaidAmount);
      setTotalPaidAmount(totalPaidAmount);
      // Calculate remaining amount
      const totalAmount = bookingDetails?.bookingSellingPrice || 0;
      const remainingAmount = Math.max(totalAmount - totalPaidAmount, 0);
      console.log("remainingAmount", remainingAmount);
      setRemaining(remainingAmount);
      
      // Check if payment is completed
      const isFullyPaid = totalPaidAmount >= totalAmount;
      setIsPaymentCompleted(isFullyPaid);
      console.log("isPaymentCompleted", isFullyPaid);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const paymentHandler = async (totalPrice, amountToPay) => {
    setIsLoading(true);
    try {
      const paymentData = {
        amount: amountToPay * 100,
        currency: "INR",
        user_id: userId,
        program_registration_id: 1,
        billing_name: user.name,
        billing_address: user.addressLine1,
      };

      const order = await PaymentService.initiatePayment(paymentData);

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: order.amount,
        currency: order.currency,
        name: "karishye",
        description: `Booking for ${
          bookingDetails?.puja_model?.puja?.name || "Puja"
        }`,
        image: process.env.REACT_APP_PAYMENT_IMAGE,
        order_id: order.id,
        handler: async function (response) {
          const transactionData = {
            booking_id: bookingDetails?.id,
            transaction_id: response.razorpay_order_id,
            razorpay_id: response.razorpay_payment_id,
            paidAmount: order.amount / 100,
            totalAmount: totalPrice,
            payment_status: "success",
            payment_type: "website",
          };
          await PaymentService.processTransaction(transactionData);
          getTransaction(bookingNumber);
          alert("Payment successful!");
          setInputPayment(0);
        },
        notes: {
          address: "Razorpay Corporate Office",
        },
        theme: {
          color: "#3399cc",
        },
      };

      const rzp1 = new window.Razorpay(options);

      rzp1.on("payment.failed", function (response) {
        alert(response.error.code);
        alert(response.error.description);
        alert(response.error.source);
        alert(response.error.step);
        alert(response.error.reason);
        alert(response.error.metadata.order_id);
        alert(response.error.metadata.payment_id);
      });

      rzp1.on("modal.closed", function () {
        document.body.style.overflow = "auto";
      });

      rzp1.open();
      document.body.style.overflow = "hidden";
    } catch (error) {
      console.error("Payment initiation error:", error);
      document.body.style.overflow = "auto";
    } finally {
      document.body.style.overflow = "auto";
      setIsLoading(false);
    }
  };

  const handleProceed = (totalPrice) => {
    let amountToPay = 0;
    if (inputPayment > 0) {
      amountToPay = inputPayment;
    } else {
      amountToPay = totalPrice;
    }
    if (amountToPay > 0) {
      const minPayment = totalPrice * 0.1;
      if (parseFloat(amountToPay) < minPayment) {
        setErrorMessage(
          `Minimum payment of 10% (₹${parseInt(minPayment - 1)}) is required.`
        );
        return;
      } else {
        setErrorMessage("");
        paymentHandler(totalPrice, amountToPay);
      }
    }
  };

  const scrollToPriceBreakup = () => {
    // First open the PriceBreakup component
    setIsPriceBreakupOpen(true);

    // Then scroll to it after a short delay to ensure it's rendered
    setTimeout(() => {
      const priceBreakupElement = document.getElementById("price-breakup");
      if (priceBreakupElement) {
        priceBreakupElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100);
  };

  // Generate status message based on current status
  const getStatusMessage = () => {
    const name = user?.name || "Customer";
    const samagriCost = calculateSamagriCost(
      bookingDetails?.bookingSamagriMappings
    );
    const samagriCostFormatted =
      samagriCost > 0 ? `₹${samagriCost.toFixed(2)}` : "₹0.00";
    const noOfPujaris = bookingDetails?.noOfPujaris || 0;
    const pujaName = bookingDetails?.puja_model?.puja?.name || "Puja";
    const hasSamagri = samagriCost > 0;

    // Check if payment is completed through API
    if (isPaymentCompleted) {
      return "Thank you for completing the booking. We look forward to provide our best service to you again in the future.";
    }

    switch (bookingDetails?.bookingStatus) {
      case "submitted":
        if (!hasSamagri) {
          return `Great choice, ${name}! Your ${pujaName} booking has been started.Our team will get in touch with you shortly to plan your puja as per your requirements.`;
        }
        return `Great choice, ${name}! Your ${pujaName} booking has been started. Our team will get in touch with you shortly to plan your puja as per your requirements`;

      case "pujari_assigned":
        if (!hasSamagri || isSamagriPaid()) {
          return `${name}, ${noOfPujaris} Pujaris has been assigned to you now.`;
        }
        return `${name}, ${noOfPujaris} Pujaris has been assigned to you now. Please check the samagiri required and completed the advance payment of ${samagriCostFormatted} only for the samagri!`;

      case "puja_confirmed":
        return `All Set, ${name}! Your Puja is Confirmed. Have a great Puja`;

      case "puja_ended":
        if (!hasSamagri) {
          return `We hope you had a divine experience, ${name}! Your ${pujaName} is now completed, Please complete the payment!`;
        }
        return `We hope you had a divine experience, ${name}! Your ${pujaName} is now completed, Please complete the remaining payment!`;

      case "payment_completed":
        return "Thank you for completing the booking. We look forward to provide our best service to you again in the future.";

      default:
        if (!hasSamagri) {
          return `Great choice, ${name}! Your ${pujaName} booking has been started. Our team will get in touch with you shortly to plan your puja as per your requirements`;
        }
        return `Great choice, ${name}! Your ${pujaName}booking has been started. Our team will get in touch with you shortly to plan your puja as per your requirements`;
    }
  };

  // Get status icon based on current status
  const getStatusIcon = () => {
    // Check if payment is completed through API
    if (isPaymentCompleted) {
      return "/assets/images/hands-praying.svg";
    }

    switch (bookingDetails?.bookingStatus) {
      case "submitted":
        return "/assets/images/celebrate-icon.svg";
      case "pujari_assigned":
        return "/assets/images/celebrate-icon.svg";
      case "puja_confirmed":
        return "/assets/images/celebrate-icon.svg";
      case "puja_ended":
        return "/assets/images/hands-praying.svg";
      case "payment_completed":
        return "/assets/images/hands-praying.svg";
      default:
        return "/assets/images/celebrate-icon.svg";
    }
  };

  // Check if samagri cost is paid or if there's no samagri
  const shouldShowPayNow = () => {
    const samagriCost = calculateSamagriCost(
      bookingDetails?.bookingSamagriMappings
    );
    const hasSamagri =
      bookingDetails?.bookingSamagriMappings &&
      bookingDetails.bookingSamagriMappings.length > 0;

    // Show "Pay Now" if:
    // 1. Samagri cost is 0 (already paid or no samagri)
    // 2. No samagri data exists
    return samagriCost === 0 || !hasSamagri;
  };

  // Check if samagri is paid (cost is 0 but samagri exists)
  const isSamagriPaid = () => {
    const samagriCost = calculateSamagriCost(
      bookingDetails?.bookingSamagriMappings
    );
    const hasSamagri =
      bookingDetails?.bookingSamagriMappings &&
      bookingDetails.bookingSamagriMappings.length > 0;

    return samagriCost === totalPaidAmount && hasSamagri;
  };

  // Modify getButtonConfig to handle remaining amount
  const getButtonConfig = () => {
    const samagriCost = calculateSamagriCost(
      bookingDetails?.bookingSamagriMappings
    );
    const hasSamagri = samagriCost > 0;

    // If payment is completed, don't show any payment button
    if (isPaymentCompleted) {
      return null;
    }

    if (bookingDetails?.bookingStatus === "puja_confirmed") {
      return {
        text: `Pay Now (₹${remaining})`,
        action: () => handleProceed(remaining),
      };
    }

    if (isSamagriPaid()) {
      return {
        text: "Pay Now",
        action: () => handleProceed(bookingDetails?.bookingSellingPrice || 0),
      };
    } else if (shouldShowPayNow() || !hasSamagri) {
      return {
        text: "Pay Now",
        action: () => handleProceed(bookingDetails?.bookingSellingPrice || 0),
      };
    } else {
      return {
        text: "Pay for Samagiri",
        action: () =>
          handleProceed(
            calculateSamagriCost(bookingDetails?.bookingSamagriMappings)
          ),
      };
    }
  };

  const handleInputChange = (e) => {
    setInputPayment(e.target.value);
  };

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = `${process.env.REACT_APP_IMAGE_URL_1236_500}/default-no-puja-image.webp`;
  };

  const fetchLatestImageUrl = async (pujaId, referenceType) => {
    if (!pujaId) return null;
    try {
      const res = await PujaService.getPujaImages(pujaId);
      console.log("Fetched images:", res);
      const images = res?.data || [];
      console.log("Fetched images:", images);
      const filteredImages = images.filter(
        (img) => img.reference_type === referenceType && img.deleted_at === null
      );
      if (filteredImages.length > 0) {
        const highestVersion = Math.max(
          ...filteredImages.map((img) => img.version || 0)
        );
        const latestImage = filteredImages.find(
          (img) => img.version === highestVersion
        );
        return latestImage?.image_url || null;
      }
      return null;
    } catch (err) {
      return null;
    }
  };

  const downloadInvoice = async () => {
    try {
      const invoiceData = {
        billTo: {
          name: user.name,
          address: user.addressLine1,
        },
        items: [
          {
            description: "Priest Expenses",
            quantity: 1,
            unitPrice: bookingDetails?.pujariCost,
            total: bookingDetails?.pujariCost,
          },
          {
            description: "Puja Material Expenses",
            quantity: 1,
            unitPrice: calculateTotalCost(
              bookingDetails?.bookingSamagriMappings
            ),
            total: calculateTotalCost(bookingDetails?.bookingSamagriMappings),
          },
          {
            description: "Service Charge",
            quantity: 1,
            unitPrice: bookingDetails?.puja_model?.serviceFee,
            total: bookingDetails?.puja_model?.serviceFee,
          },
        ],
      };
      const blob = await PaymentService.generateInvoice(invoiceData);

      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoice.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };

  const handleDownloadEstimate = async () => {
    try {
      const estimateData = {
        items: [
          { name: "Priest Expenses", qty: 1, rate: bookingDetails?.pujariCost },
          {
            name: "Puja Material Expenses",
            qty: 1,
            rate: calculateTotalCost(bookingDetails?.bookingSamagriMappings),
          },
          {
            name: "Service Charge",
            qty: 1,
            rate: bookingDetails?.puja_model?.serviceFee,
          },
        ],
      };
      const blob = await PaymentService.generateEstimate(estimateData);

      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "estimate.pdf");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading estimate:", error);
    }
  };

  // useEffect hooks
  useEffect(() => {
    setIsLoading(true);
    const localStorageUserId = localStorage.getItem("userId");

    if (!localStorageUserId || !bookingNumber) {
      setLoginModal(true);
      setIsLoading(false);
      return;
    }

    const verifyUser = async (currentUserId, bookingId) => {
      setIsLoading(true);
      try {
        const bookingDetailsResponse =
          await BookingService.getParticularBookingDetails(bookingId);
        setBookingDetails(bookingDetailsResponse);

        const bookingUserId = bookingDetailsResponse?.user?.id;

        if (bookingUserId != currentUserId) {
          setLoginModal(true);
        } else {
          setUserId(currentUserId);
        }
      } catch (error) {
        console.error("Error fetching booking details:", error);
      } finally {
        setIsLoading(false);
      }
    };
    verifyUser(localStorageUserId, bookingNumber);
  }, [bookingNumber]);

  useEffect(() => {
    setIsLoading(true);
    if (bookingNumber) {
      getTransaction(bookingNumber);
      setIsLoading(false);
    }
  }, [bookingNumber, bookingDetails]);

  useEffect(() => {
    const fetchUser = async () => {
      setIsLoading(true);
      try {
        const users = await UserService.getUserDetails();
        const currentUser = Object.values(users).find((u) => u.id === userId);
        setUser(currentUser);
      } catch (error) {
        console.error("Error fetching user:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (userId) {
      fetchUser();
    }
  }, [userId]);

  // Fetch banner image
  useEffect(() => {
    const fetchBanner = async () => {
      const url = await fetchLatestImageUrl(bookingDetails?.puja_model?.pujaId, "thumbnail");
      console.log("Thumbnail URL:", url);
      setBannerImageUrl(url);
    };
    if (bookingDetails?.puja_model?.puja?.id) {
      fetchBanner();
    }
  }, [bookingDetails?.id]);
console.log(bannerImageUrl, "bannerImageUrl")
  return (
    <div>
      {isLoading && <Loader fullScreen />}
      <Header />
      <div className="booking-detail-root">
        <section className="booking-toolbar">
          <h1 className="booking-title">
            Your Booking Details for &quot;
            {bookingDetails?.puja_model?.puja?.name || "Puja"}&quot;
          </h1>
          <div className="booking-actions">
            <button className="btn dark" onClick={downloadInvoice}>
              Invoice
            </button>
            <button className="btn dark" onClick={handleDownloadEstimate}>
              Estimate
            </button>
          </div>
        </section>

        <section
          className="booking-info-strip"
          aria-label="booking status and actions"
        >
          <div className="info-left">
            <div className="celebrate-icon">
              <img
                src={getStatusIcon()}
                alt="Status Icon"
                className="celebrate-icon-img"
              />
            </div>
            <p className="info-text">{getStatusMessage()}</p>
          </div>
          <div className="info-actions">
            {(bookingDetails?.bookingStatus === "submitted" ||
              bookingDetails?.bookingStatus === "pujari_assigned" ||
              bookingDetails?.bookingStatus === "puja_confirmed") && 
              !isPaymentCompleted && (
              <>
                {!isSamagriPaid() && (
                  <a
                    role="button"
                    className="link"
                    onClick={scrollToPriceBreakup}
                  >
                    See Price Breakup
                  </a>
                )}
                {getButtonConfig() && (
                  <button
                    className={`btn outline ${
                      isSamagriPaid() ? "full-width" : ""
                    }`}
                    onClick={getButtonConfig().action}
                  >
                    {getButtonConfig().text}
                  </button>
                )}
              </>
            )}
            {bookingDetails?.bookingStatus === "puja_ended" && !isPaymentCompleted && (
              <>
                <a
                  role="button"
                  className="link"
                  onClick={scrollToPriceBreakup}
                >
                  See Price Breakup
                </a>
                <button
                  className="btn outline"
                  onClick={() =>
                    handleProceed(bookingDetails?.bookingSellingPrice)
                  }
                >
                  Complete Payment
                </button>
              </>
            )}
            {(bookingDetails?.bookingStatus === "payment_completed" || isPaymentCompleted) && (
              <button
                className="btn outline"
                onClick={() => {
                  // Redirect to WhatsApp for feedback
                  const whatsappMessage = `Hi! I would like to share my feedback about my ${
                    bookingDetails?.puja_model?.puja?.name || "Puja"
                  } booking.`;
                  const whatsappUrl = `https://wa.me/919876543210?text=${encodeURIComponent(
                    whatsappMessage
                  )}`;
                  window.open(whatsappUrl, "_blank");
                }}
              >
                Share Feedback
              </button>
            )}
          </div>
        </section>

        <OrderStatus
          currentStatus={bookingDetails?.bookingStatus || "submitted"}
          customerName={user?.name || ""}
          noOfPujaris={bookingDetails?.puja_model?.noOfPujaris || 0}
          samagriCost={calculateSamagriCost(
            bookingDetails?.bookingSamagriMappings
          )}
          pujaName={bookingDetails?.puja_model?.pujaName || ""}
          isPaymentCompleted={isPaymentCompleted}
        />

        <main className="booking-main">
          <section className="booking-card">
            <div className="booking-card-body">
              <div className="booking-card-col">
                <div className="booking-puja-image">
                  <div className="puja-image-mask">
                    <div className="puja-image-bg">
                      <img 
                        src={bannerImageUrl} 
                        alt={'puja-image'}
                        className="Puja-Image-Full tw-h-[183px] tw-w-[187px] tw-mt-[10px] sm:tw-h-[170px] sm:tw-w-[310px]"
                        loading="lazy"
                        onError={handleImageError}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="booking-card-col details">
                <h2>{bookingDetails?.puja_model?.puja?.name || "Puja"}</h2>
                <div className="detail-grid">
                  <div className="detail-row">
                    <div className="detail">
                      <p className="label">Muhurat</p>
                      <p className="value">
                        {formatDate(bookingDetails?.muhurtam)}
                      </p>
                    </div>
                    <div className="detail">
                      <p className="label">Puja Start Date & Time</p>
                      <p className="value">
                        {formatDateTime(bookingDetails?.startDate)}
                      </p>
                    </div>
                    <div className="detail">
                      <p className="label">Puja End Date & Time</p>
                      <p className="value">
                        {formatDateTime(bookingDetails?.endDate)}
                      </p>
                    </div>
                    <div className="detail">
                      <p className="label">Puja Duration</p>
                      <p className="value">
                        {bookingDetails?.durationHrs
                          ? `${bookingDetails.durationHrs} Hours`
                          : "To Be Decided"}
                      </p>
                    </div>
                  </div>
                  <div className="detail-row">
                    <div className="detail full">
                      <p className="label">Booking Address</p>
                      <p className="value">
                        {bookingDetails?.address || "To Be Decided"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="booking-card-header">
              <h3>
                Pujari Details (No. of Pujaris:{" "}
                {bookingDetails?.noOfPujaris || 1})
              </h3>
            </div>
            <div className="booking-card-body">
              <div className="pujari-details-container">
                <div className="pujari-details-row">
                  <div className="pujari-detail-card">
                    <div className="pujari-detail-content">
                      <div className="pujari-detail-label">
                        <p>Full Name</p>
                      </div>
                      <div className="pujari-detail-value">
                        <p>
                          {bookingDetails?.pujaris?.name || "To Be Decided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="pujari-detail-card">
                    <div className="pujari-detail-content">
                      <div className="pujari-detail-label">
                        <p>Contact Number</p>
                      </div>
                      <div className="pujari-detail-value">
                        <p>
                          {bookingDetails?.pujaris?.phoneNumber ||
                            "To Be Decided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="pujari-detail-card">
                    <div className="pujari-detail-content">
                      <div className="pujari-detail-label">
                        <p>Email Id</p>
                      </div>
                      <div className="pujari-detail-value">
                        <p>
                          {bookingDetails?.pujaris?.emailId || "To Be Decided"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className={`booking-card ${!isCustomerOpen ? "collapsed" : ""}`}
          >
            <div className="booking-card-header">
              <h3>Customer Details</h3>
              <button
                type="button"
                className="section-toggle"
                onClick={() => setIsCustomerOpen(!isCustomerOpen)}
                aria-expanded={isCustomerOpen}
                aria-controls="customer-details"
              >
                <div
                  className={`caret-icon ${isCustomerOpen ? "expanded" : ""}`}
                >
                  <img alt="" src="/assets/images/caret-down.svg" />
                </div>
              </button>
            </div>
            {isCustomerOpen && (
              <div id="customer-details" className="booking-card-body">
                <div className="detail-grid">
                  <div className="detail-row">
                    <div className="detail">
                      <p className="label">First Name</p>
                      <p className="value">{user?.name || "To Be Decided"}</p>
                    </div>
                    <div className="detail">
                      <p className="label">Last Name</p>
                      <p className="value">
                        {user?.surname || "To Be Decided"}
                      </p>
                    </div>
                    <div className="detail">
                      <p className="label">Gothram</p>
                      <p className="value">{user?.gothram || "--"}</p>
                    </div>
                    <div className="detail">
                      <p className="label">Nakshatram</p>
                      <p className="value">{user?.nakshatram || "--"}</p>
                    </div>
                  </div>
                  <div className="detail-row">
                    <div className="detail">
                      <p className="label">Date of Birth</p>
                      <p className="value">
                        {formatDate(user?.dateOfBirth) || "--"}
                      </p>
                    </div>
                    <div className="detail">
                      <p className="label">Contact Number</p>
                      <p className="value">
                        {user?.phoneNumber || "To Be Decided"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </section>

          <section
            className={`booking-card ${!isProcedureOpen ? "collapsed" : ""}`}
          >
            <div className="booking-card-header">
              <h3>Puja Procedure</h3>
              <button
                type="button"
                className="section-toggle"
                onClick={() => setIsProcedureOpen(!isProcedureOpen)}
                aria-expanded={isProcedureOpen}
                aria-controls="puja-procedure"
              >
                <div
                  className={`caret-icon ${isProcedureOpen ? "expanded" : ""}`}
                >
                  <img alt="" src="/assets/images/caret-down.svg" />
                </div>
              </button>
            </div>
            {isProcedureOpen && (
              <div id="puja-procedure" className="booking-card-body">
                <div className="notes-comments-container">
                  {bookingDetails?.bookingproceduremappings?.map(
                    (procedure, index) => (
                      <div key={index} className="note-item">
                        <div className="note-content">
                          <div className="note-author">
                            <p>
                              {index + 1}. {procedure?.procedure?.title}
                            </p>
                          </div>
                          <div className="note-details">
                            <div className="note-text-container">
                              <p className="note-text">
                                {procedure?.procedure?.description ||
                                  "No description available"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  ) || (
                    <div className="note-item">
                      <div className="note-content">
                        <div className="note-author">
                          <p>1. Aashirvachanam</p>
                        </div>
                        <div className="note-details">
                          <div className="note-text-container">
                            <p className="note-text">
                              Blessing ceremony to invoke divine presence
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </section>

          <section
            className={`booking-card ${!isNotesOpen ? "collapsed" : ""}`}
          >
            <div className="booking-card-header">
              <h3>Notes/Comments</h3>
              <button
                type="button"
                className="section-toggle"
                onClick={() => setIsNotesOpen(!isNotesOpen)}
                aria-expanded={isNotesOpen}
                aria-controls="notes-comments"
              >
                <div className={`caret-icon ${isNotesOpen ? "expanded" : ""}`}>
                  <img alt="" src="/assets/images/caret-down.svg" />
                </div>
              </button>
            </div>
            {isNotesOpen && (
              <div id="notes-comments" className="booking-card-body">
                <div className="notes-comments-container">
                  {bookingDetails?.customerNotes && (
                    <div className="note-item">
                      <div className="note-content">
                        <div className="note-author">
                          <p>Customer</p>
                        </div>
                        <div className="note-details">
                          <div className="note-text-container">
                            <p className="note-text">
                              {bookingDetails?.customerNotes}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="note-item">
                    <div className="note-content">
                      <div className="note-author">
                        <p>Karishye</p>
                      </div>
                      <div className="note-details">
                        <div className="note-text-container">
                          <p className="note-text">
                            {bookingDetails?.pujariKarishyeNotes}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {bookingDetails?.pujaris?.name && (
                    <div className="note-item">
                      <div className="note-content">
                        <div className="note-author">
                          <p>{bookingDetails?.pujaris.name} (Pujari)</p>
                        </div>
                        <div className="note-details">
                          <div className="note-text-container">
                            <p className="note-text">
                              {bookingDetails?.pujariCustomerNotes}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </section>

          {/* Samagiri List Section */}
          <section className="booking-card">
            <SamagiriList
              samagiriData={bookingDetails?.bookingSamagriMappings || []}
            />
          </section>

          {/* Pujari Samagiri Section */}
          <section className="booking-card">
            <PujariSamagiri
              samagiriData={bookingDetails?.bookingSamagriMappings || []}
            />
          </section>

          {/* Karishye Samagiri Section */}
          <section className="booking-card">
            <KarishyeSamagiri
              samagiriData={bookingDetails?.bookingSamagriMappings || []}
            />
          </section>

          {/* Price Breakup Section */}
          <section id="price-breakup" className="booking-card">
            <PriceBreakup
              bookingDetails={bookingDetails}
              onSamagriPayment={(samagriCost) => handleProceed(samagriCost)}
              onFullPayment={(totalAmount) => handleProceed(remaining)}
              isExpanded={isPriceBreakupOpen}
              onToggle={setIsPriceBreakupOpen}
              bookingStatus={bookingDetails?.bookingStatus}
              remainingAmount={remaining}
              isPaymentCompleted={isPaymentCompleted}
              isSamagriPaid={isSamagriPaid()}
            />
          </section>
        </main>
      </div>

      <LoginModal
        title={"Login"}
        fromDetail={true}
        frombooking={false}
        setSignupFormData={setSignupFormData}
        signupFormData={signupFormData}
        setLoginModal={setLoginModal}
        loginModal={loginModal}
        style={{ display: loginModal ? "flex" : "none" }}
      />

      <Footer />
      <Whatsapp />
    </div>
  );
}

export default EachBooking;
